var _a;
import Immutable from 'seamless-immutable';
import { createSelector } from 'reselect';
import { LOCATION_CHANGE } from 'connected-react-router';
import { handleActions } from 'redux-actions';
import { AppConstant } from 'constants/app.constant';
var reducer = handleActions((_a = {},
    _a[LOCATION_CHANGE] = function (state, action) { return state.merge({ locationBeforeTransitions: action.payload }); },
    _a), Immutable({ locationBeforeTransitions: null }));
var getRouteState = function (state) { return state[AppConstant.reduxResources.ROUTER]; };
var routerSelectors = {
    getLocation: createSelector(getRouteState, function (state) { return (state ? state.location : {}); }),
    getSearch: createSelector(getRouteState, function (state) { return (state ? state.location.search : ''); })
};
export { reducer as routeReducer, routerSelectors };
